export const TRANSLATIONS_EN = {
  'welcome': "Welcome to home page",
  // 'login':"Login",
  // 'temple':"Temple booking",
  // 'change':"Change theme",
  // 'read':"Most visited temples",
  // 'email':"Email Address",
  // 'pass':"Password",
  // 'p_email':"Enter your email",
  // 'p_pass':"Enter your password",
  // 'submit':"Submit",
  // 'Viewbooking':"Viewbooking"
};
